module.exports = __webpack_public_path__ + "static/media/starwarslogo.1bb952ef.png";